export const latestGossip = [
  {
    id: 1,
    slug: "top-star-secret-romance-exposed",
    title: "顶流明星深夜密会曝光，知情人士爆料已秘密交往一年",
    category: "明星爆料",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Evening%20urban%20scene%20with%20two%20silhouettes%20walking%20in%20dim%20street%20light%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20blurred%20background%20with%20city%20lights%2C%20warm%20evening%20tones%2C%20dramatic%20lighting%2C%20soft%20focus%2C%20candid%20moment%20captured&width=800&height=600&seq=gossip-card-01&orientation=landscape",
    date: "2026-06-28",
    views: 128000,
    excerpt: "据知情人士透露，两位一线明星已秘密交往超过一年，多次被拍到深夜密会。",
    isNew: true,
  },
  {
    id: 2,
    slug: "internet-celebrity-scandal-live",
    title: "某千万粉丝网红直播翻车，黑历史被扒引发全网热议",
    category: "网红黑料",
    categorySlug: "influencer-gossip",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20live%20streaming%20interface%20with%20chat%20comments%2C%20dramatic%20red%20and%20dark%20lighting%2C%20social%20media%20drama%20aesthetic%2C%20digital%20screen%20glow%2C%20tense%20atmosphere%2C%20modern%20streaming%20setup%2C%20intense%20mood&width=800&height=600&seq=gossip-card-02&orientation=landscape",
    date: "2026-06-27",
    views: 96000,
    excerpt: "知名网红在直播中被网友扒出早年黑历史，直播间弹幕瞬间炸锅。",
    isNew: true,
  },
  {
    id: 3,
    slug: "variety-show-controversy",
    title: "热门综艺录制现场冲突，两位嘉宾因一句玩笑话当场翻脸",
    category: "综艺爆料",
    categorySlug: "show-gossip",
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20two%20chairs%20facing%20each%20other%20on%20stage%2C%20dramatic%20spotlight%20effect%2C%20reality%20show%20aesthetic%2C%20tension%20in%20the%20air%2C%20professional%20studio%20lighting%2C%20behind%20the%20scenes%20vibe&width=800&height=600&seq=gossip-card-03&orientation=landscape",
    date: "2026-06-26",
    views: 85000,
    excerpt: "综艺节目录制中两位嘉宾因玩笑话产生误会，现场气氛一度十分尴尬。",
    isNew: false,
  },
  {
    id: 4,
    slug: "actress-divorce-details",
    title: "知名女星被曝已协议离婚，财产分割细节意外流出",
    category: "明星爆料",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20silhouette%20walking%20alone%20on%20city%20street%20at%20sunset%2C%20reflective%20mood%2C%20luxury%20handbag%2C%20dramatic%20backlighting%2C%20golden%20hour%20tones%2C%20fashion%20editorial%20style%2C%20melancholic%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=600&seq=gossip-card-04&orientation=landscape",
    date: "2026-06-25",
    views: 112000,
    excerpt: "结婚仅三年的知名女星被曝已与丈夫协议离婚，涉及数亿资产分割。",
    isNew: false,
  },
];

export const hotRanking = [
  {
    rank: 1,
    title: "顶流男星私生子传闻持续发酵",
    category: "明星爆料",
    views: "256万",
    trend: "up",
    slug: "top-star-secret-romance-exposed",
  },
  {
    rank: 2,
    title: "知名导演被多人实名举报",
    category: "娱乐圈内幕",
    views: "198万",
    trend: "up",
    slug: "director-reported",
  },
  {
    rank: 3,
    title: "某组合成员内部不和曝光",
    category: "偶像团体",
    views: "167万",
    trend: "up",
    slug: "group-conflict",
  },
  {
    rank: 4,
    title: "网红带货翻车被品牌方索赔",
    category: "网红黑料",
    views: "145万",
    trend: "down",
    slug: "internet-celebrity-scandal-live",
  },
  {
    rank: 5,
    title: "大牌明星代言涉嫌虚假宣传",
    category: "明星爆料",
    views: "132万",
    trend: "up",
    slug: "endorsement-scandal",
  },
  {
    rank: 6,
    title: "选秀节目黑幕被前工作人员曝光",
    category: "综艺爆料",
    views: "118万",
    trend: "up",
    slug: "show-controversy",
  },
  {
    rank: 7,
    title: "女星整容前后对比照意外流出",
    category: "明星爆料",
    views: "105万",
    trend: "new",
    slug: "plastic-surgery-leak",
  },
  {
    rank: 8,
    title: "知名主播涉嫌偷税漏税被查",
    category: "网红黑料",
    views: "98万",
    trend: "up",
    slug: "tax-evasion-case",
  },
];

export const encyclopediaCards = [
  {
    id: 1,
    slug: "how-to-spot-fake-gossip",
    title: "如何辨别娱乐圈真假黑料？资深娱记教你三招",
    excerpt: "娱乐圈真假消息满天飞，学会这三招辨别技巧，不再被营销号带节奏。",
    category: "黑料百科",
    image: "https://readdy.ai/api/search-image?query=Detective%20style%20desk%20with%20magnifying%20glass%20over%20newspaper%20clippings%2C%20warm%20tungsten%20desk%20lamp%20lighting%2C%20vintage%20investigation%20aesthetic%2C%20dark%20wooden%20desk%20surface%2C%20notebooks%20and%20photos%20scattered%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows&width=1000&height=700&seq=encyclopedia-01&orientation=landscape",
    readingTime: "5分钟",
    isLarge: true,
  },
  {
    id: 2,
    slug: "entertainment-industry-unspoken-rules",
    title: "娱乐圈潜规则大揭秘：新人入行必知的那些事",
    excerpt: "新人入行前必须了解的娱乐圈潜规则，保护自己的同时也能更快适应。",
    category: "黑料百科",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20professional%20cinematography%20setup%2C%20green%20screen%20background%2C%20movie%20production%20atmosphere%2C%20creative%20workspace%2C%20cinematic%20lighting&width=800&height=500&seq=encyclopedia-02&orientation=landscape",
    readingTime: "8分钟",
    isLarge: false,
    colorClass: "bg-secondary-100/60",
  },
  {
    id: 3,
    slug: "history-of-gossip-culture",
    title: "黑料文化起源：从香港八卦到全民吃瓜的演变史",
    excerpt: "从香港八卦杂志到微博热搜，中国吃瓜文化的三十年变迁。",
    category: "黑料百科",
    image: "https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20tabloid%20magazine%20rack%20with%20colorful%20covers%2C%20nostalgic%20newsstand%20scene%2C%20warm%20retro%20lighting%2C%20Cantonese%20street%20scene%20background%2C%20old%20school%20aesthetic%2C%20faded%20colors%2C%20cultural%20documentary%20style&width=800&height=500&seq=encyclopedia-03&orientation=landscape",
    readingTime: "6分钟",
    isLarge: false,
    colorClass: "bg-accent-100/60",
  },
];

export const featuredStats = [
  { value: "1280万+", label: "月活跃用户", icon: "ri-user-line" },
  { value: "5.6万+", label: "每日爆料更新", icon: "ri-flashlight-line" },
  { value: "98%", label: "用户满意度", icon: "ri-heart-line" },
  { value: "3200万+", label: "累计阅读量", icon: "ri-eye-line" },
];

export const categories = [
  { name: "明星爆料", slug: "star-gossip", icon: "ri-star-line", count: 1280 },
  { name: "网红黑料", slug: "influencer-gossip", icon: "ri-live-line", count: 960 },
  { name: "综艺爆料", slug: "show-gossip", icon: "ri-tv-line", count: 756 },
  { name: "娱乐圈内幕", slug: "industry-insider", icon: "ri-spy-line", count: 632 },
  { name: "偶像团体", slug: "idol-group", icon: "ri-group-line", count: 518 },
  { name: "电竞八卦", slug: "esports-gossip", icon: "ri-gamepad-line", count: 445 },
];

export const testimonials = [
  {
    id: 1,
    name: "娱乐小达人",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20casual%20fashion%2C%20friendly%20expression%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "黑料网真的是我每天的快乐源泉！更新速度超快，料也很足，比微博热搜还精彩。",
    rating: 5,
    date: "2026-06-20",
  },
  {
    id: 2,
    name: "吃瓜群众老王",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20thirties%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot%2C%20approachable%20look&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "作为资深吃瓜群众，对比了多家八卦平台，黑料网的内容质量和更新频率确实是顶级的。",
    rating: 5,
    date: "2026-06-18",
  },
  {
    id: 3,
    name: "娱乐圈观察者",
    avatar: "https://readdy.ai/api/search-image?query=Stylish%20young%20Chinese%20woman%20portrait%2C%20elegant%20look%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20modern%20fashion%2C%20confident%20expression%2C%20editorial%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish",
    comment: "黑料百科栏目真的很涨知识，学到了很多辨别真假八卦的技巧，分享给朋友后她们也都关注了。",
    rating: 4,
    date: "2026-06-15",
  },
];
